import { create } from 'zustand';

const useDashboardStore = create((set) => ({
  stats: null,
  attacks: [],
  alerts: [],
  assets: [],
  securityScore: null,
  vulnerabilities: [],
  compliance: [],
  isLoading: false,
  error: null,

  setStats: (stats) => set({ stats }),
  setAttacks: (attacks) => set({ attacks }),
  setAlerts: (alerts) => set({ alerts }),
  setAssets: (assets) => set({ assets }),
  setSecurityScore: (securityScore) => set({ securityScore }),
  setVulnerabilities: (vulnerabilities) => set({ vulnerabilities }),
  setCompliance: (compliance) => set({ compliance }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
}));

export default useDashboardStore;
